import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatMetricVisualization = createCustomElementWrapper('kat-metric-visualization', 'KatMetricVisualization', {
    'class': 'class',
}, {});
